import { eachDayOfInterval, endOfWeek, format, parseISO, startOfWeek } from 'date-fns';
import { resolveActiveDateFnsLocale } from '@/i18n/dateFnsLocale';

export const WEEK_STARTS_ON_MONDAY = { weekStartsOn: 1 } as const;

export function formatDateToMonthAndYear(dateValue: Date): string {
  return format(dateValue, 'LLLL yyyy', { locale: resolveActiveDateFnsLocale() });
}

export function formatDateToFullWeekdayDate(dateValue: Date): string {
  return format(dateValue, 'EEEE, d MMMM yyyy', { locale: resolveActiveDateFnsLocale() });
}

export function formatDateToDayMonthYear(dateValue: Date): string {
  return format(dateValue, 'd MMMM yyyy', { locale: resolveActiveDateFnsLocale() });
}

export function formatIsoDateToDayAndMonth(isoDate: string): string {
  return format(parseISO(isoDate), 'd MMM', { locale: resolveActiveDateFnsLocale() });
}

export function formatIsoDateAndTimeToHistoryLabel(isoDate: string, timeValue: string): string {
  return formatDateToDayMonthYear(parseISO(isoDate)) + ', ' + timeValue;
}

export function formatIsoDateTimeToTimestamp(isoDateTime: string): string {
  return format(parseISO(isoDateTime), 'd MMM yyyy, HH:mm', {
    locale: resolveActiveDateFnsLocale(),
  });
}

export function formatIsoDateTimeAsWallClock(isoDateTimeWithOffset: string): string {
  const wallClockPart = isoDateTimeWithOffset.substring(0, 19);
  return format(parseISO(wallClockPart), 'd MMM yyyy, HH:mm', {
    locale: resolveActiveDateFnsLocale(),
  });
}

export function formatIsoDateTimeToTimeOnly(isoDateTime: string): string {
  return format(parseISO(isoDateTime), 'HH:mm', { locale: resolveActiveDateFnsLocale() });
}

export function formatDateToShortWeekday(dateValue: Date): string {
  return format(dateValue, 'EEE', { locale: resolveActiveDateFnsLocale() });
}

export function formatDateToDayOfMonthNumber(dateValue: Date): string {
  return format(dateValue, 'd', { locale: resolveActiveDateFnsLocale() });
}

export function formatDateToIsoDateOnly(dateValue: Date): string {
  return format(dateValue, 'yyyy-MM-dd');
}

export function buildLocalizedWeekdayShortLabels(): string[] {
  const referenceDate = new Date();
  const weekStart = startOfWeek(referenceDate, WEEK_STARTS_ON_MONDAY);
  const weekEnd = endOfWeek(referenceDate, WEEK_STARTS_ON_MONDAY);
  const weekDays = eachDayOfInterval({ start: weekStart, end: weekEnd });
  return weekDays.map(formatDateToShortWeekday);
}
